export const HelpScoutBeacon = {
  install(app, options) {
    const loadBeacon = (w, d) => {
      function loadScript() {
        const firstScript = d.getElementsByTagName('script')[0]
        const newScript = d.createElement('script')
        newScript.type = 'text/javascript'
        newScript.async = true
        newScript.src = 'https://beacon-v2.helpscout.net'
        firstScript.parentNode.insertBefore(newScript, firstScript)
      }

      const beaconFn = function (method, beaconOptions, data) {
        w.Beacon.readyQueue.push({ method, options: beaconOptions, data })
      }
      w.Beacon = beaconFn
      beaconFn.readyQueue = []

      if (d.readyState === 'complete') {
        return loadScript()
      }

      if (w.attachEvent) {
        w.attachEvent('onload', loadScript)
      }
      else {
        w.addEventListener('load', loadScript, false)
      }
    }

    const switchBeacon = function (locale) {
      loadBeacon(window, document)
      window.Beacon('init', options.localeIds[locale])
    }

    options.router.afterEach((to, from) => {
      if (!options.stores.getters.isAuthenticated && window.Beacon) {
        window.Beacon('destroy')
        window.Beacon = undefined
      }
      else if (
        options.stores.getters.isAuthenticated
        && window.Beacon === undefined
      ) {
        loadBeacon(window, document)
        window.Beacon('init', options.localeIds[to.params.locale])
      }
      else if (
        options.stores.getters.isAuthenticated
        && from.params.locale
        && from.params.locale !== to.params.locale
      ) {
        loadBeacon(window, document)
        window.Beacon('init', options.localeIds[to.params.locale])
      }
    })

    app.config.globalProperties.$switchBeacon = switchBeacon
    app.provide('switchBeacon', switchBeacon)
  },
}
